<style lang="stylus">
.logo-persis
  max-height 50px
</style>
<template lang="pug">
footer.footerbar
  .flex-row.d-flex.ad_bg-gray
    .d-flex.col-12.pb-2.pt-3.justify-content-center
      img.logo-persis(src="../../static/images/logo.svg" alt="Persis")
  .flex-row.d-flex.ad_bg-secondary
    .d-flex.col-12.py-1.justify-content-center
      small.text-white Desarrollado por 
        a#persismail(href="mailto:soporteadherencia@persis.cl")
          | Persis &copy;
        b-tooltip(target="persismail" , placement='top')
          | ¿Necesitas <b>Soporte</b>
          br
          | o tienes <b>Sugerencias</b>?
          br
          | Contáctanos
</template>

<script>
export default {
  name: 'FooterBar',
  data () {
    return {
      
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/footer.vue